
export function paymentTypeInitial(label) {
	const text = (label ?? "").trim();
	if (!text) return "پ";
	return text.charAt(0);
}

export function paymentProductHref(payment) {
	if (!payment) return null;
	if (payment.product_type === "workshop" && payment.workshop) {
		return `/workshop_detail/${payment.workshop}/`;
	}
	if (payment.product_type === "webinar" && payment.webinar) {
		return `/webinar_detail/${payment.webinar}/`;
	}
	if (payment.product_type === "subscription") {
		return "/subscriptions/";
	}
	return null;
}

export function paymentProductActionLabel(payment) {
	if (!payment) return null;
	if (payment.product_type === "workshop") return "مشاهده کارگاه";
	if (payment.product_type === "webinar") return "مشاهده وبینار";
	if (payment.product_type === "subscription") return "مشاهده اشتراک‌ها";
	return null;
}
